module.exports = __webpack_public_path__ + "static/media/partners_main_m.f495a1b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_mobile/partners_main_m.mp4
// module id = FUST
// module chunks = 0